import { getIROExamDurationMinutes } from "../../utils/commonUtils";

export const initialState = {
  passage: {},
  questionsList: [],
  has_next: false,
  already_attempt: false,
  next_page: 0,
  total_passages: 0,
  timerMinutes: getIROExamDurationMinutes(),
  timerSeconds: 0,
  // state for Camera & Mic
  trackList: [],
  isTimerRunning : true,
};
